import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumb } from 'antd';
import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import Card from "components/Card/Card.js";
import CardFooter from "components/Card/CardFooter";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchSubCodeLevels
} from "../../../../reduxToolkit/features/SubCodeLevel/SubCodeLevelConfigSlice";
import {fetchCodeLevels} from "reduxToolkit/features/CodeLevel/CodeLevelConfigSlice";
import DropDownSubCodeLevelButton from "../../../Components/DropDownSubCodeLevelButton";



const useStyles = makeStyles(styles);
const useNavBarStyles = makeStyles(navBarStyles);
const useTitleStyles = makeStyles(titleStyles);
const useCardStyles = makeStyles(cardStyles);

export default function SubCodeLevelPage() {
  const cardClasses = useCardStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navBarClasses = useNavBarStyles();
  const titleClasses = useTitleStyles();
  const classes = useStyles();
  const codeLevelStatus = useSelector(
    (state) => state.subLevelClo.SubCodeLevelsStatus
  );
  console.log("status codeLevelStatus", codeLevelStatus);

  useEffect(() => {
    dispatch(fetchSubCodeLevels());
    dispatch(fetchCodeLevels());

  }, [dispatch]);

  const SubCodeLevels = useSelector((state) => state.subLevelClo.SubCodeLevels);
  const error = useSelector((state) => state.subLevelClo.error);
  const codeLevels = useSelector((state) => state.CodeLevel.codeLevels);
  console.log("SubCodeLevels", SubCodeLevels);
  console.log("codeLevels", codeLevels);
  return (
    <div>
      <GridContainer
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <GridItem>

          <Breadcrumb separator=">">
            <Breadcrumb.Item >

              {t('Configurations')}

            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/course`}>
                <span > {t('Course Configurations')} </span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/configuration/course/subCodeLevels`}>
                <span > {t('Code Sub Levels')} </span>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>

      </GridContainer>


      <Link to="/citrine/configuration/course/subCodeLevels/create">
        <Button color="info">{t("  Add")}</Button>
      </Link>

      <GridContainer md={12} xs={12} sm={12}>
        {SubCodeLevels &&
          SubCodeLevels.map((codeLevel) => (
            <GridItem xs={12} sm={12} md={4} key={codeLevel.id} >
              <Card style={{ maxWidth: "380px", minWidth: "380px", maxHeight: "180px", minHeight: "180px" }} cardHover >
                <CardHeader>
                  <GridContainer direction="row"
                    justifyContent="space-between"
                    alignItems="baseline">
                    <GridItem xs={10} sm={10} md={10}>
                      <h4 className={cardClasses.cardProductTitle}>
                        Sub Level: {codeLevel.subLevelClo_level}
                      </h4>
                      <h5 className={cardClasses.cardProductTitle}>
                        Sub Level Code: {codeLevel.subLevelClo_code_level}
                      </h5>
                      <h5 className={cardClasses.cardProductTitle}>
                        Level: {codeLevel.levelClo_level}
                      </h5>
                     
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <DropDownSubCodeLevelButton id={codeLevel.id} />
                    </GridItem>
                  </GridContainer>
                </CardHeader>

                <CardFooter>
                  <GridContainer
                    direction="row"
                    justify="flex-end"
                    alignItems="center">
                    {/* <GridItem> <span style={{ color: (program.state) === "Draft" ? grayColor[1] : "#FFCB3B" }}>{program.state}</span> </GridItem> */}
                  </GridContainer>
                </CardFooter>
              </Card>
            </GridItem>
          ))
        }
      </GridContainer>
    </div>
  );
}
